import { getUserGuideRecords, setUserGuideRecords } from '@/services/api.index'
const firstVisit = {
    state: {
        projectDownload: false,
    },
    mutations: {
        SET_PROJECT_DOWNLOAD(state, data) {
            state.projectDownload = data
            localStorage.setItem("projectDownload", data)
        }
    },
    actions: {
        /**
         * 获取首次访问记录
         * @param {Object} params - 参数对象
         * @param {string} params.key - localStorage 中存储的 key(同state)
         * @param {string} params.modules - 后端接收枚举
         * @param {string} params.mutations - 对应的mutations
         */
        async getRecords({ commit, state }, params) {
            let value = localStorage.getItem(params.key)
            if (!value) {
                let res = await getUserGuideRecords(params.modules)
                value = res.data.length ?  "true" : "false" 
            }
            commit(params.mutations, value === "false" ? false : true)
        },
        /**
         * 更新首次访问记录
         * @param {Object} params - 参数对象
         * @param {string} params.guideModule - 后端接收枚举
         * @param {string} params.mutations - 对应的mutations
         * @param {string} params.value - 更新的值
         */
        setRecords({ commit, state }, params) {
            setUserGuideRecords({guideModule:params.guideModule}).finally(()=>{
                commit(params.mutations, params.value)
            })     
        }
    }
}
export default firstVisit


// WEBPACK FOOTER //
// ./src/store/modules/firstVisit.js